export default __webpack_public_path__ + "static/media/instagram.61333ec0.svg";